import { isAxiosError } from 'axios';

/**
 * The message the API responded with. Axios errors carry it in response.data (NestJS body:
 * { statusCode, message, error }) while error.message is just "Request failed with status code 400";
 * validation errors arrive as a message array.
 */
export function getApiErrorMessage(error: unknown): string | undefined {
  if (!isAxiosError(error)) return undefined;
  const message = (error.response?.data as { message?: string | string[] } | undefined)?.message;
  return Array.isArray(message) ? message.join(', ') : message;
}
